/**
 * Credit control permission codes (FT4-B6, `internal/ar/permissions.go:65-68`).
 *
 * Kept beside the feature because `modules/ar/permissions.ts` is outside this
 * packet's files; the strings are the server's own, so a rename there is a grep
 * away. Each one is the permission its route declares (`internal/ar/handler.go`):
 *
 *   GET  /ar-credit-exposure                     ar.credit.read
 *   POST /customers/:id/credit-hold              ar.credit.hold
 *   POST /customers/:id/credit-release           ar.credit.release
 *   POST /customers/:id/credit-limit-requests    ar.credit_limit.request
 *   GET  /customers/:id/credit-limit-requests    ar.credit.read
 */
export const AR_CREDIT_PERMISSIONS = {
  read: 'ar.credit.read',
  hold: 'ar.credit.hold',
  release: 'ar.credit.release',
  limitRequest: 'ar.credit_limit.request',
} as const
